import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IFormSelectInputOption } from '@modules/forms/types';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_GROUP_POSTBACKS } from '@modules/postbacks/constants';

export interface PostbackTypesComposable {
  typeOptions: Ref<IFormSelectInputOption<string>[]>;
}

export default function usePostbackTypes(): PostbackTypesComposable {
  const { getTranslation } = useI18n();

  const typeOptions = computed<IFormSelectInputOption<string>[]>(() => [
    {
      value: 'registration',
      label: getTranslation(TRANSLATION_GROUP_POSTBACKS, 'TAB_REGISTRATION').value,
    },
    {
      value: 'deposit',
      label: getTranslation(TRANSLATION_GROUP_POSTBACKS, 'TAB_DEPOSIT').value,
    },
    {
      value: 'activity',
      label: getTranslation(TRANSLATION_GROUP_POSTBACKS, 'TAB_ACTIVITY').value,
    },
  ]);

  return {
    typeOptions,
  };
}
